<div
  *ngIf="title && title.text"
  [style.color]="textColor"
  [style.fontSize.px]="title.size"
  [style.textAlign]="title.align"
  class="title"
>
  {{ title.text }}
</div>

<div
  *ngIf="this.chartOptions.transpose === 'rows'"
  [class.paginated-table]="pages?.length > 1"
  class="table-container"
>
  <table
    class="ui very basic table"
    [style.color]="textColor"
    [style.fontSize.px]="textSize"
  >
    @if (result) {
    <thead>
      <tr>
        @for (col of orderedColumns; track col.id) { @if (col.id === spacerBeforeColumnId) {
        <th
          class="spacer"
          [attr.rowspan]="groupedHeader ? 2 : null"
        ></th>
        } @switch (col.kind) { @case ('metric') { @if (!separateColumn || groupedHeader) {
        <th
          [attr.draggable]="canReorderColumns && dragHandleArmed ? 'true' : null"
          (dragstart)="onDragStart($event, col)"
          (dragover)="onDragOver($event, col)"
          (dragleave)="onDragLeave(col)"
          (drop)="onDrop($event, col)"
          (dragend)="onDragEnd()"
          [attr.colspan]="groupedHeader ? 2 : null"
          [ngClass]="{
            'center aligned': groupedHeader,
            'tw-shadow-[inset_3px_0_0_#2185d0]': dropTargetId === col.id,
            'tw-opacity-40': draggingId === col.id
          }"
          class="metric"
          [class.wrapped]="isWrapped(col.metric.displayName)"
          [style.color]="textColor"
        >
          <div class="column-header-content">
            @if (canReorderColumns) {
            <i
              class="fa-solid fa-grip-vertical column-grip"
              (mousedown)="armDrag()"
            ></i>
            }
            <span [wrapMiddle]="col.metric.displayName"></span>
          </div>
        </th>
        } @else {
        <th
          [attr.draggable]="canReorderColumns && dragHandleArmed ? 'true' : null"
          (dragstart)="onDragStart($event, col)"
          (dragover)="onDragOver($event, col)"
          (dragleave)="onDragLeave(col)"
          (drop)="onDrop($event, col)"
          (dragend)="onDragEnd()"
          class="min-width wrapped metric"
          [ngClass]="{
            'tw-shadow-[inset_3px_0_0_#2185d0]': dropTargetId === col.id,
            'tw-opacity-40': draggingId === col.id
          }"
          [style.color]="textColor"
        >
          <div class="column-header-content">
            @if (canReorderColumns) {
            <i
              class="fa-solid fa-grip-vertical column-grip"
              (mousedown)="armDrag()"
            ></i>
            }
            <span>
              <span
                class="metric-name"
                [wrapMiddle]="col.metric.displayName"
              ></span>
              <br />
              <span
                class="period-label"
                [style.fontSize.px]="textSize * 0.86"
              >
                {{ benchmarkDatesLabel }}
              </span>
            </span>
          </div>
        </th>
        <th
          [attr.draggable]="canReorderColumns && dragHandleArmed ? 'true' : null"
          (dragstart)="onDragStart($event, col)"
          (dragover)="onDragOver($event, col)"
          (dragleave)="onDragLeave(col)"
          (drop)="onDrop($event, col)"
          (dragend)="onDragEnd()"
          class="min-width wrapped metric"
          [ngClass]="{
            'tw-shadow-[inset_3px_0_0_#2185d0]': dropTargetId === col.id,
            'tw-opacity-40': draggingId === col.id
          }"
          [style.color]="textColor"
        >
          <div class="column-header-content">
            @if (canReorderColumns) {
            <i
              class="fa-solid fa-grip-vertical column-grip"
              (mousedown)="armDrag()"
            ></i>
            }
            <span>
              <span
                class="metric-name"
                [wrapMiddle]="col.metric.displayName"
              ></span>
              <br />
              <span
                class="period-label"
                [style.fontSize.px]="textSize * 0.86"
              >
                {{ currentDatesLabel }}
              </span>
            </span>
          </div>
        </th>
        } } @default {
        <th
          [attr.draggable]="canReorderColumns && dragHandleArmed ? 'true' : null"
          (dragstart)="onDragStart($event, col)"
          (dragover)="onDragOver($event, col)"
          (dragleave)="onDragLeave(col)"
          (drop)="onDrop($event, col)"
          (dragend)="onDragEnd()"
          class="min-width dimension"
          [class.wrapped]="col.kind === 'property'"
          [attr.rowspan]="groupedHeader ? 2 : null"
          [ngClass]="{
            'tw-shadow-[inset_3px_0_0_#2185d0]': dropTargetId === col.id,
            'tw-opacity-40': draggingId === col.id
          }"
          [style.color]="textColor"
        >
          <div class="column-header-content">
            @if (canReorderColumns) {
            <i
              class="fa-solid fa-grip-vertical column-grip"
              (mousedown)="armDrag()"
            ></i>
            }
            <span>
              @switch (col.kind) {
              @case ('rollup') { {{ result.query?.rollup?.name }} }
              @case ('dimension') { {{ col.dimension.displayName }} }
              @case ('property') { {{ col.dimension.displayName }}<br />{{ col.property.displayName }} }
              }
            </span>
          </div>
        </th>
        } } }
      </tr>
      @if (groupedHeader) {
      <tr>
        @for (col of orderedMetricColumns; track col.id) {
        <th
          class="metric"
          [style.color]="textColor"
          [style.fontSize.px]="textSize * 0.86"
        >
          {{ benchmarkDatesLabel }}
        </th>
        <th
          class="metric"
          [style.color]="textColor"
          [style.fontSize.px]="textSize * 0.86"
        >
          {{ currentDatesLabel }}
        </th>
        }
      </tr>
      }
    </thead>
    } @if (result && pages?.length) {
    <tbody>
      @for (row of pages[currentPageNum]; track $index; let i = $index) {
      <tr class="clickable">
        @for (col of orderedColumns; track col.id) { @if (col.id === spacerBeforeColumnId) {
        <td class="spacer"></td>
        } @switch (col.kind) { @case ('rollup') {
        <td
          [pTooltip]="comparisonDateTooltip(comparisonDatePages?.[currentPageNum]?.[i])"
          tooltipStyleClass="comparison-date-tooltip"
          tooltipPosition="left"
        >
          {{ row.date | date : dateFormat }}
        </td>
        } @case ('dimension') {
        <td>{{ row.slices[col.dimensionIndex].value | format : row.slices[col.dimensionIndex].format }}</td>
        } @case ('property') { @let prop = row.slices[col.dimensionIndex].properties?.[col.propertyIndex];
        <td>{{ prop?.value | format : prop?.format }}</td>
        } @case ('metric') { @let m = row.metrics[col.metricIndex]; @if (separateColumn) {
        <td class="metric">
          @if (!loadingBenchmarks) {
          <span class="value">
            {{ benchmarkValuePages?.[currentPageNum]?.[i]?.[m.name] | format : getMetricFormat(m.name, m.format) }}
          </span>
          }
        </td>
        }
        <td
          [style]="{ 'background-color': conditionalColor(col.metricIndex, m) }"
          class="metric"
        >
          <span class="value">{{ m.value | format : getMetricFormat(m.name, m.format) }}</span>
          <benchmark-result
            [style.fontSize.px]="textSize * 0.86"
            [benchmark]="
              benchmarkPages &&
              benchmarkPages[currentPageNum] &&
              benchmarkPages[currentPageNum][i] &&
              benchmarkPages[currentPageNum][i][m.name]
            "
            [benchmarkClassName]="
              benchmarkPages &&
              benchmarkPages[currentPageNum] &&
              benchmarkPages[currentPageNum][i] &&
              benchmarkPages[currentPageNum][i][m.name]
                ? getBenchmarkClassNames(getComparison(m), benchmarkPages[currentPageNum][i][m.name])
                : ''
            "
            [timePeriod]="compareTo"
            [comparisonDate]="comparisonDatePages ? comparisonDatePages[currentPageNum]?.[i] : comparisonDateRange"
            [loadingBenchmarks]="loadingBenchmarks"
            [displayAs]="benchmarksAs"
            [difference]="benchmarkDifference(i, m.name, m.value)"
            [differenceFormat]="getMetricFormat(m.name, m.format)"
          ></benchmark-result>
        </td>
        } } }
      </tr>
      } @if (showColumnGrandTotals) {
      <tr>
        @for (col of orderedColumns; track col.id) { @if (col.id === spacerBeforeColumnId) {
        <td class="spacer"></td>
        } @if (col.kind === 'metric') { @let t = datesAsRowsTotalsByMetric[col.metric.name]; @if (separateColumn) {
        <td class="metric summary">
          @if (t && !t.hide && !loadingBenchmarks) {
          {{ benchmarkPageTotals[col.metric.name] | format : t.format }}
          }
        </td>
        }
        <td class="metric summary">
          @if (t && !t.hide) {
          {{ t.value | format : t.format }}
          @if (separateColumn) {
          <benchmark-result
            [style.fontSize.px]="textSize * 0.86"
            [benchmark]="totalBenchmark(t.value, benchmarkPageTotals[col.metric.name])"
            [benchmarkClassName]="
              totalBenchmark(t.value, benchmarkPageTotals[col.metric.name])
                ? getBenchmarkClassNames(
                    getComparison(col.metric),
                    totalBenchmark(t.value, benchmarkPageTotals[col.metric.name])
                  )
                : ''
            "
            [timePeriod]="compareTo"
            [loadingBenchmarks]="loadingBenchmarks"
            [displayAs]="benchmarksAs"
            [difference]="totalDifference(t.value, benchmarkPageTotals[col.metric.name])"
            [differenceFormat]="t.format"
          ></benchmark-result>
          } }
        </td>
        } @else {
        <td [class]="col.id === firstNonMetricColumnId ? 'total' : 'spacer'">
          @if (col.id === firstNonMetricColumnId) { Page Total }
        </td>
        } }
      </tr>
      } @if (showColumnAllPagesTotals) {
      <tr>
        @for (col of orderedColumns; track col.id) { @if (col.id === spacerBeforeColumnId) {
        <td class="spacer"></td>
        } @if (col.kind === 'metric') { @let total = result.totals[col.metric.name]; @if (separateColumn) {
        <td class="metric summary">
          @if (!loadingBenchmarks) {
          {{
            benchmarkTotals?.[col.metric.name]?.value != null
              ? (benchmarkTotals[col.metric.name].value | format : getMetricFormat(col.metric.name, benchmarkTotals[col.metric.name].format))
              : '-'
          }}
          }
        </td>
        }
        <td class="metric summary">
          {{ total?.value !== null ? (total.value | format : getMetricFormat(col.metric.name, total.format)) : '-' }}
          @if (separateColumn) {
          <benchmark-result
            [style.fontSize.px]="textSize * 0.86"
            [benchmark]="totalBenchmark(total?.value, benchmarkTotals?.[col.metric.name]?.value)"
            [benchmarkClassName]="
              totalBenchmark(total?.value, benchmarkTotals?.[col.metric.name]?.value)
                ? getBenchmarkClassNames(getComparison(col.metric), totalBenchmark(total?.value, benchmarkTotals?.[col.metric.name]?.value))
                : ''
            "
            [timePeriod]="compareTo"
            [loadingBenchmarks]="loadingBenchmarks"
            [displayAs]="benchmarksAs"
            [difference]="totalDifference(total?.value, benchmarkTotals?.[col.metric.name]?.value)"
            [differenceFormat]="getMetricFormat(col.metric.name, col.metric.format)"
          ></benchmark-result>
          }
        </td>
        } @else {
        <td [class]="col.id === firstNonMetricColumnId ? 'total' : 'spacer'">
          @if (col.id === firstNonMetricColumnId) { Grand Total }
        </td>
        } }
      </tr>
      }
    </tbody>
    }
  </table>
  <pagination
    [pages]="pages"
    [initialPage]="initialPageNum"
    [resetPageNumOnChange]="true"
    (currentPageNumChange)="updateCurrentPageNum($event)"
  ></pagination>
</div>

<div
  *ngIf="this.chartOptions.transpose === 'columns'"
  [class.paginated-table]="uniqueSlices?.length > 1"
  class="table-container"
>
  <table
    class="ui celled structured table"
    [style.color]="textColor"
    [style.backgroundColor]="backgroundColor"
    [style.fontSize.px]="textSize"
  >
    @if (result) {
    <thead [style.backgroundColor]="backgroundColor">
      <tr>
        @for (col of orderedColumns; track col.id) { @if (col.kind === 'metric') {
        <th
          [attr.draggable]="canReorderColumns && dragHandleArmed ? 'true' : null"
          (dragstart)="onDragStart($event, col)"
          (dragover)="onDragOver($event, col)"
          (dragleave)="onDragLeave(col)"
          (drop)="onDrop($event, col)"
          (dragend)="onDragEnd()"
          class="center aligned"
          [attr.colspan]="uniqueDates.length"
          [ngClass]="{
            'tw-shadow-[inset_3px_0_0_#2185d0]': dropTargetId === col.id,
            'tw-opacity-40': draggingId === col.id
          }"
          [style.color]="textColor"
          [style.backgroundColor]="backgroundColor"
        >
          <div class="column-header-content">
            @if (canReorderColumns) {
            <i
              class="fa-solid fa-grip-vertical column-grip"
              (mousedown)="armDrag()"
            ></i>
            }
            <span>{{ col.metric.displayName }}</span>
          </div>
        </th>
        } @else {
        <th
          [attr.draggable]="canReorderColumns && dragHandleArmed ? 'true' : null"
          (dragstart)="onDragStart($event, col)"
          (dragover)="onDragOver($event, col)"
          (dragleave)="onDragLeave(col)"
          (drop)="onDrop($event, col)"
          (dragend)="onDragEnd()"
          rowspan="2"
          [class.wrapped]="col.kind === 'property'"
          [ngClass]="{
            'tw-shadow-[inset_3px_0_0_#2185d0]': dropTargetId === col.id,
            'tw-opacity-40': draggingId === col.id
          }"
          [style.color]="textColor"
          [style.backgroundColor]="backgroundColor"
        >
          <div class="column-header-content">
            @if (canReorderColumns) {
            <i
              class="fa-solid fa-grip-vertical column-grip"
              (mousedown)="armDrag()"
            ></i>
            }
            <span>
              @if (col.kind === 'property') {
              {{ col.dimension.displayName }}
              <br />
              {{ col.property.displayName }}
              } @else {
              {{ col.dimension.displayName }}
              }
            </span>
          </div>
        </th>
        } } @if (showRowGrandTotals) { @for (col of orderedMetricColumns; track col.id) {
        <th
          class="center aligned"
          [attr.colspan]="uniqueDates.length"
          [style.color]="textColor"
          [style.backgroundColor]="backgroundColor"
        >
          {{ col.metric.displayName }}
        </th>
        } }
      </tr>
      @if (result.query?.rollup?.value !== 'total') {
      <tr>
        @for (col of orderedColumns; track col.id) { @if (col.kind === 'metric') { @for (date of uniqueDates; track
        $index; let dateIndex = $index) {
        <th
          [pTooltip]="comparisonDateTooltip(comparisonDates?.[dateIndex])"
          tooltipStyleClass="comparison-date-tooltip"
          tooltipPosition="left"
          [style.color]="textColor"
          [style.backgroundColor]="backgroundColor"
        >
          {{ date | date : dateFormat }}
        </th>
        } } } @if (showRowGrandTotals) { @for (col of orderedMetricColumns; track col.id) {
        <th
          class="center aligned"
          [attr.colspan]="uniqueDates.length"
          [style.color]="textColor"
          [style.backgroundColor]="backgroundColor"
        >
          Page Total
        </th>
        } }
      </tr>
      }
    </thead>
    } @if (result) {
    <tbody>
      @for (row of uniqueSlices[currentPageNum]; track $index; let rowIndex = $index) { @let series =
      resultSeries[rowIndex + resultsPerPage * currentPageNum];
      <tr class="clickable">
        @for (col of orderedColumns; track col.id) { @switch (col.kind) { @case ('dimension') {
        <td>{{ row[col.dimensionIndex].value }}</td>
        } @case ('property') { @let prop = row[col.dimensionIndex].properties?.[col.propertyIndex];
        <td>{{ prop?.value | format : prop?.format }}</td>
        } @case ('metric') { @let m = series.metrics[col.metricIndex]; @for (value of m.values; track $index; let
        valueIndex = $index) {
        <td
          [style]="{ 'background-color': conditionalColor(valueIndex, m) }"
          class="metric"
        >
          <span class="value">{{ value | format : getMetricFormat(m.name, m.format) }}</span>
          <benchmark-result
            [style.fontSize.px]="textSize * 0.86"
            [benchmark]="
              benchmarkPages &&
              benchmarkPages[currentPageNum] &&
              benchmarkPages[currentPageNum][rowIndex] &&
              benchmarkPages[currentPageNum][rowIndex][m.name] &&
              benchmarkPages[currentPageNum][rowIndex][m.name][valueIndex]
            "
            [benchmarkClassName]="
              benchmarkPages &&
              benchmarkPages[currentPageNum] &&
              benchmarkPages[currentPageNum][rowIndex] &&
              benchmarkPages[currentPageNum][rowIndex][m.name] &&
              benchmarkPages[currentPageNum][rowIndex][m.name][valueIndex]
                ? getBenchmarkClassNames(getComparison(m), benchmarkPages[currentPageNum][rowIndex][m.name][valueIndex])
                : ''
            "
            [timePeriod]="compareTo"
            [comparisonDate]="comparisonDates?.[valueIndex]"
            [loadingBenchmarks]="loadingBenchmarks"
          ></benchmark-result>
        </td>
        } } } } @if (showRowGrandTotals) { @for (col of orderedMetricColumns; track col.id) { @let t =
        datesAsColumnsRowTotals[rowIndex]?.[col.metricIndex];
        <td
          [attr.colspan]="uniqueDates.length"
          class="metric summary"
        >
          {{ t?.value | format : t?.format }}
        </td>
        } }
      </tr>
      } @if (showColumnGrandTotals) {
      <tr>
        @for (col of orderedColumns; track col.id) { @if (col.kind === 'metric') { @for (t of
        datesAsColumnsColTotalsByMetric[col.metricIndex]; track $index) {
        <td class="metric summary">
          @if (!t.hide) {
          {{ t.value | format : t.format }}
          }
        </td>
        } } @else {
        <td [class]="col.id === firstNonMetricColumnId ? 'total' : ''">
          @if (col.id === firstNonMetricColumnId) { Page Total }
        </td>
        } } @if (showRowGrandTotals) { @for (col of orderedMetricColumns; track col.id) { @let t =
        datesAsColumnsTotalOfTotals[col.metricIndex];
        <td
          [attr.colspan]="uniqueDates.length"
          class="metric summary"
        >
          @if (t && !t.hide) {
          {{ t.value | format : t.format }}
          }
        </td>
        } }
      </tr>
      }
    </tbody>
    }
  </table>

  <pagination
    [pages]="uniqueSlices"
    [initialPage]="initialPageNum"
    [resetPageNumOnChange]="true"
    (currentPageNumChange)="updateCurrentPageNum($event)"
  ></pagination>
</div>

<div
  *ngIf="!!footer"
  class="table-footer"
>
  <span *ngIf="footer.datasetInfo">{{ footerData.datasetInfo }}</span>
  <span *ngIf="footer.dateRange">Widget date range: {{ footerData.dateRange }}</span>
  @if (footer.comparisonDateRange && comparisonDateRange) {
  <span>Comparison date range: {{ comparisonDateRange }}</span>
  }
</div>
